(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-comparison-table"] && !Shopify.designMode) return;
  try {
    
  // Synchronize row heights between left and right tables
  const syncRowHeights = () => {
    const leftTables = document.querySelectorAll('.sd-comparison-table__table--left');

    leftTables.forEach((leftTable) => {
      const rightTable = leftTable.closest('.sd-comparison-table__wrapper')?.querySelector('.sd-comparison-table__table--right');

      if (!rightTable) return;

      // Sync header heights
      const leftHeader = leftTable.querySelector('thead tr');
      const rightHeader = rightTable.querySelector('thead tr');

      if (leftHeader && rightHeader) {
        // Reset heights
        leftHeader.style.height = '';
        rightHeader.style.height = '';

        // Get natural heights (getBoundingClientRect for sub-pixel precision)
        const leftHeaderHeight = leftHeader.getBoundingClientRect().height;
        const rightHeaderHeight = rightHeader.getBoundingClientRect().height;
        const maxHeaderHeight = Math.max(leftHeaderHeight, rightHeaderHeight);

        // Apply max height to both
        leftHeader.style.height = `${maxHeaderHeight}px`;
        rightHeader.style.height = `${maxHeaderHeight}px`;
      }

      // Sync body row heights
      const leftRows = leftTable.querySelectorAll('tbody tr');
      const rightRows = rightTable.querySelectorAll('tbody tr');

      leftRows.forEach((leftRow, index) => {
        const rightRow = rightRows[index];

        if (!rightRow) return;

        // Reset heights
        leftRow.style.height = '';
        rightRow.style.height = '';

        // Get natural heights (getBoundingClientRect for sub-pixel precision)
        const leftRowHeight = leftRow.getBoundingClientRect().height;
        const rightRowHeight = rightRow.getBoundingClientRect().height;
        const maxRowHeight = Math.max(leftRowHeight, rightRowHeight);

        // Apply max height to both
        leftRow.style.height = `${maxRowHeight}px`;
        rightRow.style.height = `${maxRowHeight}px`;
      });
    });
  };

  // Consolidated initialization - runs once on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', () => {
    // =========================================================================
    // 1. COLUMN TOGGLE FUNCTIONALITY
    // =========================================================================
    const initColumnToggles = () => {
      const checkboxes = document.querySelectorAll('[data-checkbox]');

      if (checkboxes.length === 0) return;

      let lastClickedCheckbox = null;
      let columnWidthsLocked = false;

      // Lock column widths to prevent reflow when hiding columns
      const lockColumnWidths = () => {
        if (columnWidthsLocked) return;

        const table = document.querySelector('.sd-comparison-table__table');
        if (!table) return;

        // Get all headers
        const headers = table.querySelectorAll('.sd-comparison-table__column-header');

        // Lock each header width
        headers.forEach((header) => {
          const width = header.offsetWidth;
          header.style.width = `${width}px`;
          header.style.minWidth = `${width}px`;
          header.style.maxWidth = `${width}px`;
        });

        // Lock each cell width by getting cells from first row
        const firstRow = table.querySelector('.sd-comparison-table__row');
        if (firstRow) {
          const cells = firstRow.querySelectorAll('.sd-comparison-table__cell');
          cells.forEach((cell) => {
            const width = cell.offsetWidth;
            const columnId = cell.getAttribute('data-column');
            const allCellsInColumn = table.querySelectorAll(`.sd-comparison-table__cell[data-column="${columnId}"]`);
            allCellsInColumn.forEach((c) => {
              c.style.width = `${width}px`;
              c.style.minWidth = `${width}px`;
              c.style.maxWidth = `${width}px`;
            });
          });
        }

        // Lock corner cell
        const cornerCell = table.querySelector('.sd-comparison-table__corner-cell');
        if (cornerCell) {
          const width = Math.min(cornerCell.offsetWidth, 310);
          cornerCell.style.width = `${width}px`;
          cornerCell.style.minWidth = `${width}px`;
          cornerCell.style.maxWidth = `${width}px`;
        }

        // Lock row headers
        const rowHeaders = table.querySelectorAll('.sd-comparison-table__row-header');
        rowHeaders.forEach((header) => {
          const width = Math.min(header.offsetWidth, 310);
          header.style.width = `${width}px`;
          header.style.minWidth = `${width}px`;
          header.style.maxWidth = `${width}px`;
        });

        columnWidthsLocked = true;
      };

      // Function to show all columns
      const showAllColumns = () => {
        const allColumns = document.querySelectorAll('[data-column]');
        allColumns.forEach((col) => {
          col.classList.remove('comparison-column--hidden');
        });

        const table = document.querySelector('.sd-comparison-table__table');
        if (table) {
          table.classList.remove('sd-comparison-table__table--filtered');
        }
      };

      // Function to update column visibility
      const updateColumns = (columnToShow) => {
        lockColumnWidths();

        // Hide ALL columns first
        const allColumns = document.querySelectorAll('[data-column]');
        allColumns.forEach((col) => {
          col.classList.add('comparison-column--hidden');
        });

        // Show base columns
        const baseColumns = document.querySelectorAll('.sd-comparison-table__column-header--base, .sd-comparison-table__cell--base');
        baseColumns.forEach((col) => {
          col.classList.remove('comparison-column--hidden');
        });

        // Always show first column (column-1)
        const firstColumns = document.querySelectorAll('[data-column="column-1"]');
        firstColumns.forEach((col) => {
          col.classList.remove('comparison-column--hidden');
        });

        // Show the selected column
        const selectedColumns = document.querySelectorAll(`[data-column="${columnToShow}"]`);
        selectedColumns.forEach((col) => {
          col.classList.remove('comparison-column--hidden');
        });

        const table = document.querySelector('.sd-comparison-table__table');
        if (table) {
          table.classList.add('sd-comparison-table__table--filtered');
        }
      };

      // Handle checkbox clicks
      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('click', () => {
          if (lastClickedCheckbox === checkbox) {
            checkbox.checked = false;
            lastClickedCheckbox = null;
            showAllColumns();
            return;
          }

          checkboxes.forEach((cb) => {
            cb.checked = false;
          });

          checkbox.checked = true;
          lastClickedCheckbox = checkbox;
          updateColumns(checkbox.value);
        });
      });
    };

    // =========================================================================
    // 2. SCROLL ANIMATION (INTERSECTION OBSERVER)
    // =========================================================================
    const initScrollAnimation = () => {
      const animatedTables = document.querySelectorAll('[data-animate="true"]');

      if (!animatedTables.length) return;

      const observerOptions = {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.1
      };

      const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('sd-comparison-table--animated');
            observer.unobserve(entry.target);
          }
        });
      };

      const observer = new IntersectionObserver(observerCallback, observerOptions);

      animatedTables.forEach(table => {
        const rect = table.getBoundingClientRect();
        const isInView = rect.top < window.innerHeight && rect.bottom > 0;

        if (isInView) {
          requestAnimationFrame(() => {
            table.classList.add('sd-comparison-table--animated');
          });
        } else {
          observer.observe(table);
        }
      });
    };

    // =========================================================================
    // 3. ROW HEIGHT SYNCHRONIZATION
    // =========================================================================
    const initRowSync = () => {
      // Sync immediately
      syncRowHeights();

      // Sync again after short delays for theme editor
      setTimeout(syncRowHeights, 100);
      setTimeout(syncRowHeights, 300);
      setTimeout(syncRowHeights, 500);

      // Set up MutationObserver to watch for content changes
      const tables = document.querySelectorAll('.sd-comparison-table__table--left, .sd-comparison-table__table--right');

      tables.forEach((table) => {
        const observer = new MutationObserver(() => {
          clearTimeout(window.comparisonTableSyncTimeout);
          window.comparisonTableSyncTimeout = setTimeout(syncRowHeights, 50);
        });

        observer.observe(table, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: false
        });
      });
    };

    // Run all initializations
    initColumnToggles();
    initScrollAnimation();
    initRowSync();
  });

  // Re-sync on window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(syncRowHeights, 100);
  });

  // Shopify theme editor events
  document.addEventListener('shopify:section:load', () => {
    setTimeout(syncRowHeights, 100);
    setTimeout(syncRowHeights, 300);
  });

  document.addEventListener('shopify:section:select', () => {
    setTimeout(syncRowHeights, 100);
  });

  document.addEventListener('shopify:section:reorder', () => {
    setTimeout(syncRowHeights, 100);
  });

  document.addEventListener('shopify:block:select', () => {
    setTimeout(syncRowHeights, 100);
  });

  document.addEventListener('shopify:block:deselect', () => {
    setTimeout(syncRowHeights, 100);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-product-grid"] && !Shopify.designMode) return;
  try {
    
  // Position promotional cards in grid based on their data attributes
  document.querySelectorAll('.section-sd-product-grid').forEach(section => {
    section.querySelectorAll('.sd-promotional-card-wrapper[data-promo-position]').forEach(promoCard => {
      const position = promoCard.getAttribute('data-promo-position');
      const span = promoCard.getAttribute('data-promo-span') || '1';
      const listItem = promoCard.closest('.resource-list__item');

      if (listItem && position) {
        // Subtract 1 so position N appears at slot N (products have order 1,2,3...)
        listItem.style.order = parseInt(position, 10) - 1;
        listItem.style.setProperty('--promo-span', span);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
